export default "__VITE_ASSET__BKig7a9L__"